
import React, { useContext } from 'react';
import { SettingsSearchContext } from './SettingsContext';
import { InfoPopup } from './InfoPopup';

interface SectionLabelProps {
  children?: React.ReactNode;
  icon?: string;
  darkMode: boolean;
  tooltip?: string;
  modes?: string[];
}

export const SectionLabel: React.FC<SectionLabelProps> = ({ children, icon, darkMode, tooltip, modes }) => {
  const searchQuery = useContext(SettingsSearchContext);
  
  if (searchQuery) return null; // Flatten list when searching

  return (
    <div className="w-full flex items-center gap-3 mt-7 mb-4">
      <div className={`flex-1 h-px ${darkMode ? 'bg-white/5' : 'bg-neutral-100'}`} />
      <span className="text-base font-black uppercase tracking-wider opacity-100 flex items-center gap-2">
        {icon && <i className={`fa-solid ${icon} text-lg opacity-100`}></i>}
        {children}
        {tooltip && <InfoPopup content={tooltip} modes={modes} darkMode={darkMode} />}
      </span>
      <div className={`flex-1 h-px ${darkMode ? 'bg-white/5' : 'bg-neutral-100'}`} />
    </div>
  );
};
